import { Badge } from "@/components/ui/badge";

export interface CaseStudy {
  id: number;
  businessName: string;
  industry: string;
  image: string;
  before: {
    title: string;
    problems: string[];
  };
  after: {
    title: string;
    solutions: string[];
  };
  roi: {
    metric: string;
    value: string;
    timeframe: string;
  };
  testimonial: {
    quote: string;
    author: string;
    role: string;
  };
}

interface CaseStudyStripProps {
  caseStudy: CaseStudy;
  onClick?: () => void;
}

const CaseStudyStrip = ({ caseStudy, onClick }: CaseStudyStripProps) => {
  return (
    <div 
      onClick={onClick}
      className="flex items-start gap-6 p-8 hover:bg-muted/30 transition-colors cursor-pointer group"
    >
      {/* Imagen circular minimalista */}
      <img 
        src={caseStudy.image} 
        alt={caseStudy.businessName}
        className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover flex-shrink-0 grayscale group-hover:grayscale-0 transition-all"
      />
      
      {/* Contenido minimalista */}
      <div className="flex-1 min-w-0 space-y-3">
        {/* Línea 1: Nombre + Industria */}
        <div className="flex flex-wrap items-baseline gap-3">
          <h4 className="text-xl sm:text-2xl font-light text-foreground">
            {caseStudy.businessName}
          </h4>
          <span className="text-sm sm:text-base text-muted-foreground font-light">
            {caseStudy.industry}
          </span>
        </div>
        
        {/* Línea 2: ROI limpio */}
        <p className="text-base sm:text-lg font-medium text-foreground">
          {caseStudy.roi.timeframe} · {caseStudy.roi.value}
        </p>
        
        {/* Línea 3: Testimonial limpio */}
        <p className="text-sm sm:text-base text-muted-foreground line-clamp-2 font-light">
          "{caseStudy.testimonial.quote}"
        </p>
      </div>
    </div>
  );
};

export default CaseStudyStrip;
